import React from 'react'

import { Wrapper } from '@farewill/ui'

import TrustpilotCarousel from 'components/TrustpilotWidget/TrustpilotCarousel'

import SliceHero from './slices/SliceHero'
import SliceProducts from './slices/SliceProducts'
import SliceAwardWinning from './slices/SliceAwardWinning'

const Content = (): React.ReactElement => (
  <>
    <SliceHero />
    <Wrapper container containerPaddingTop={0}>
      <TrustpilotCarousel container={false} />
    </Wrapper>
    <SliceProducts />
    <Wrapper padding={[0, 0, 'M']} paddingFromL={[0, 0, 'XL']}>
      <SliceAwardWinning />
    </Wrapper>
  </>
)

export default Content
